<template lang="pug">
  div(style="width:100%; height:100%; min-height:300px;")
    v-chart(:options="innerOptions" :autoresize="true")

</template>

<script>
    import ECharts from './echart'
    import 'echarts/lib/chart/line'
    import 'echarts/lib/component/polar'

    import 'echarts-gl'

    export default {
        name: 'b-chart-pie',
        props: ['data', 'labels', 'options'],
        data() {
            return {}
        },
        computed: {
            innerData() {
                let series = [this.format({data: [], name: null})]

                this.$props.data.forEach(row => {
                    let dataIndex = this.labels.indexOf(row.label)
                    if (!series[0].data[dataIndex]) series[0].data[dataIndex] = { name: row.label, value: 0 }
                    series[0].data[dataIndex].value += row.value
                })

                return series
            },
            innerOptions() {
                let orientation = null
                let serie = this.innerData[0]
                if (serie) {
                    orientation = serie.data.length > 4 ? 'vertical' : 'horizontal'
                }

                return {
                    title: {
                        text: this.$props.options.showTitle ? this.$props.options.title : null,
                        textStyle: {
                            color: '#346899',
                            fontSize: '18',
                        },
                        top: '0',
                        left: 'center',
                    },
                    legend: {
                        type: orientation == 'vertical' ? 'scroll' : null,
                        orient: orientation,
                        right: 10,
                        top: orientation == 'vertical' ? 20 : 50,
                        bottom: 20,
                    },
                    backgroundColor: this.$props.options.backgroundColor,
                    footer: this.$props.options.footer,
                    color: this.$props.options.colors,
                    grid: {
                        top: orientation == 'vertical' ? '3%' : '20%',
                        left: '3%',
                        right: orientation == 'vertical' ? '20%' : '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: (params) => {
                            let b = params[params.$vars[1]]
                            let c = params[params.$vars[2]]
                            let prefix = this.$props.options.prefix || ''
                            let suffix = this.$props.options.suffix || ''
                            return `${b}: ${prefix} ${c.toLocaleString('es-PY')} ${suffix}`
                        }
                    },
                    series: this.innerData,
                    animationDuration: 2000
                }
            }
        },
        methods: {
            format(serie) {
                serie.type = 'pie'

                serie.label = {
                    show: true,
                    position: 'inside'
                }

                serie.emphasis = {
                    label: {
                        fontSize: 20
                    }
                }

                switch (this.$props.options.type) {
                    case 'funnel':
                        serie.type = 'funnel'
                        break
                    case 'pie-doughnut':
                        serie.radius = ['50%', '70%']
                        break
                    case 'pie-rose-type':
                        serie.radius = [100, 200]
                        serie.center = ['50%', '50%']
                        serie.roseType = 'area'
                        break
                    default:
                        serie.radius = '55%'
                        break
                }

                return serie
            },
        },
        components: {
            'v-chart': ECharts
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// pie.vue